<template>
    <div class="mt-2">
        <table class="table table-sm border table-totals mb-2">
            <tbody>
                <tr>
                    <td class="product px-2">Sub-Total Amount</td>
                    <td class="comma-sep">:</td>
                    <td class="price text-right px-2">{{ subTotal }}</td>
                </tr>
                <tr>
                    <td class="product px-2">Total VAT</td>
                    <td class="comma-sep">:</td>
                    <td class="price text-right px-2">{{ totalVAT }}</td>
                </tr>
                <tr>
                    <td class="product px-2">Total Trade Discount</td>
                    <td class="comma-sep">:</td>
                    <td class="price text-right px-2">{{ discountAmount || 0 }}</td>
                </tr>
                <tr>
                    <td class="product px-2">Total Bill Amount</td>
                    <td class="comma-sep">:</td>
                    <td class="price text-right px-2">{{ total }}</td>
                </tr>
                <tr>
                    <td class="product px-2">Service Charge</td>
                    <td class="comma-sep">:</td>
                    <td class="price px-2">
                        <input
                            v-model.number="serviceChargeAmount"
                            type="number" min="0" class="form-control form-control-sm text-right"
                            placeholder="amount"
                        />
                    </td>
                </tr>
                <tr>
                    <td class="product px-2">Discount / Round up Adj</td>
                    <td class="comma-sep">:</td>
                    <td class="price px-2">
                        <input
                            v-model.number="discountAmount"
                            type="number" min="0" class="form-control form-control-sm text-right"
                            placeholder="amount"
                        />
                    </td>
                </tr>
                <tr>
                    <td class="product px-2">Net Bill</td>
                    <td class="comma-sep">:</td>
                    <td class="price text-right px-2">{{ grandTotal }}</td>
                </tr>
            </tbody>
        </table>

        <div>
            <MoneyReceiptForm :grand-total="grandTotal" :force-full-payment="props.forceFullPayment"/>
        </div>
    </div>
</template>

<script setup>
import MoneyReceiptForm from '@/components/molecule/company/hospital/billing/MoneyReceiptForm.vue';
import { computed, inject, ref, watch } from 'vue';

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
    forceFullPayment: {
        type: Boolean,
        default: false,
    }
});

const formData = inject('formData');

const discountAmount = ref(0);
const serviceChargeAmount = ref(0);

const lineAmount = (item) => {
    return Number(item.quantity) * Number(item.rate);
};

const subTotal = computed(() => {
    let sum = 0;
    for (const item of props.items) {
        sum += lineAmount(item);
    }
    return sum;
});

const totalVAT = computed(() => {
    return 0;
});

const total = computed(() => {
    return subTotal.value + totalVAT.value;
});

const grandTotal = computed(() => {
    return total.value - (discountAmount.value || 0) + (serviceChargeAmount.value || 0);
});

watch(discountAmount, () => {
    formData.value.adjustment_amount = discountAmount.value || 0;
});

watch(serviceChargeAmount, () => {
    formData.value.service_charge_amount = serviceChargeAmount.value || 0;
});
</script>

<style scoped>
.table-totals {
    font-weight: bold;
}
.product {
    width: 60%;
}
.comma-sep {
    text-align: right;
}
</style>
